var render = function render(){var _vm=this,_c=_vm._self._c;return _c('answers',{ref:"answers",attrs:{"code_question_group":"GQ31","danger_code":"MCAL13","unique_category":true,"show_next":_vm.showNext}})
}
var staticRenderFns = []

export { render, staticRenderFns }